import React from 'react';
import { typographyCaption } from 'lib/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledLabel = styled.span`
  ${({ theme }) => css`
    ${typographyCaption(theme)};
    color: ${theme.color.text.light.secondary.value};
    font-size: ${theme.font.size.caption.value};
  `}
`;

export const SliderHelperText = ({ children, dataTestId = '', ...other }) => {
  return (
    <StyledLabel data-testid={dataTestId ? `${dataTestId}-helper-text` : undefined} {...other}>
      {children}
    </StyledLabel>
  );
};

SliderHelperText.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
};
